import OfficeLandingListing from './OfficeLandingListing';

export { type OfficeLandingListingProps } from './OfficeLandingListing';
export default OfficeLandingListing;
